import { render, staticRenderFns } from "./GameTrackingPage.vue?vue&type=template&id=0b05ee1d&scoped=true"
import script from "./GameTrackingPage.vue?vue&type=script&lang=js"
export * from "./GameTrackingPage.vue?vue&type=script&lang=js"
import style0 from "./GameTrackingPage.vue?vue&type=style&index=0&id=0b05ee1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05ee1d",
  null
  
)

export default component.exports